import type {
  LotDto,
  InventoryTypeDtoInventoryTypesEnum,
} from '@b-stock/listing-api-client'

type PartialLot = Pick<LotDto, 'overrides'>

export const getLotInventoryTypes = (
  lot?: PartialLot
): InventoryTypeDtoInventoryTypesEnum[] => {
  // Note: There are no non-override inventory types, so we just need to look at the "overrides"
  return (
    lot?.overrides?.inventoryTypes?.flatMap(
      ({ inventoryTypes }) => inventoryTypes ?? []
    ) ?? []
  )
}
